import React from 'react';
import { View } from '../../../../../components/Common/react-native-components';
import { Icons, Typography } from '@hmsexp/component-library';
import styles from './style';
import { get } from 'lodash';

const ProsConsItem = props => {
    const { item, isProsTabActive } = props;

    return (
        <View style={styles.prosConsItemMainContainer}>
            <View style={styles.prosConsItemContainer}>
                <View style={styles.row}>
                    <Typography variant='h6'>{item.title}</Typography>
                    <View
                        style={[
                            styles.mentionsItem,
                            { backgroundColor: isProsTabActive ? '#E8F7EB' : '#FAE8E9' }
                        ]}
                    >
                        <Typography
                            fontWeightType='bold'
                            variant='caption'
                            textProps={{
                                style: { color: isProsTabActive ? '#0E4122' : '#D51B25' }
                            }}
                        >
                            {item?.frequency} Mention{item?.frequency == 1 ? '' : 's'}
                        </Typography>
                    </View>
                </View>

                <View style={styles.explanationContainer}>
                    <View style={styles.flexRow}>
                        <Icons.InfoIcon size='M' />
                        <Typography fontWeightType='regular'>Explanation</Typography>
                    </View>
                    <View style={styles.explanationTextContainer}>
                        <Typography fontWeightType='semiBold'>{item?.explanation}</Typography>
                    </View>
                </View>

                <View style={styles.guestQuotedContainer}>
                    <View>
                        <View style={styles.flexRow}>
                            <Icons.MessageIcon size='M' />
                            <Typography fontWeightType='regular'>Guest Quotes</Typography>
                        </View>
                        <View style={styles.guestQuotedTextContainer}>
                            {get(item, 'quotes', []).map((res, ind) => {
                                return (
                                    <View style={styles.flexRow} key={ind}>
                                        <Typography
                                            fontWeightType='medium'
                                            textProps={{ style: styles.italicText }}
                                        >
                                            {'\u2022'}{" "}
                                            {res}
                                        </Typography>
                                    </View>
                                );
                            })}
                        </View>
                    </View>
                </View>
            </View>
        </View>
    );
};

export default ProsConsItem;